<template>
  <div>
    <el-dialog title='上传确认书' :visible.sync='updateDialogPDF' width='30%' @close='updateClose'>
      <el-form label-width='100px'>

        <el-form-item label='上传文件'>
          <input ref='files' @change='update' type='file' hidden />
          <el-button class='btn' size='small' @click='openFile'>点击上传</el-button>
          <span v-if='files' style='padding-left: 10px;'>已上传 {{ files.name }}</span>
          <span v-else style='padding-left: 10px;'>未上传</span>
        </el-form-item>
      </el-form>
      <span slot='footer' class='dialog-footer'>
        <el-button @click='updateDialogPDF= false'>取 消</el-button>
        <el-button type='primary' @click='updateSendmail'>保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { uploadBookByOrderId } from '@/api/order/order'

export default {
  name: 'sendmail',
  data() {
    return {
      updateDialogPDF: false,
      files: '',
      formData: '',
      orderId: ''
    }
  },
  methods: {
    editDialog(orderId) {
      this.orderId = orderId
      this.updateDialogPDF = true
    },

    updateClose() {
      this.orderId = ''
    },

    updateSendmail() {
      if (!this.orderId || this.orderId === '') {
        this.$message.error('订单不存在!')
      } else {
        this.formData = new FormData()
        this.formData.append('file', this.files)
        uploadBookByOrderId(this.orderId, this.formData).then(res => {
          if (res.code === '0' && res.data) {
            this.$message.success('上传成功!')
            this.orderId = ''
            this.updateDialogPDF = false
          } else {
            this.$message.error('上传失败')
          }
        })

      }

    },

    openFile() {
      this.$refs.files.click()
    },

    update() {
      this.files = this.$refs.files.files[0]
    }
  }
}
</script>

<style scoped>

</style>
